<div class="notification-item" [class.unread]="!notification.read_at">
  <div class="notification-content" (click)="handleNotificationClick()">
    <!-- Snoozed Label -->
    <div *ngIf="notification.was_snoozed" class="snoozed-label">
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 14L8 11.3333L4 14V3.33333C4 2.97971 4.14048 2.64057 4.39052 2.39052C4.64057 2.14048 4.97971 2 5.33333 2H10.6667C11.0203 2 11.3594 2.14048 11.6095 2.39052C11.8595 2.64057 12 2.97971 12 3.33333V14Z"
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span>{{ 'notifications.snoozed' | translate }}</span>
    </div>

    <!-- Main Title -->
    <h4 class="notification-title">
      {{ notification.content }}
    </h4>

    <!-- Service Type -->
    <p class="service-type"
      *ngIf="notification.enrichedMetadata?.serviceInfo?.service_name && notification.enrichedMetadata?.serviceInfo?.service_name?.toLowerCase() !== 'unknown'">
      {{ notification.enrichedMetadata.serviceInfo?.service_name }}
    </p>

    <!-- Action Button -->
    <div class="action-container">
      <button *ngIf="notification.enrichedMetadata?.action" class="action-button" (click)="handleActionClick($event)">
        {{ notificationService.getActionText(getActionType(notification.enrichedMetadata.action?.type)) }}
        <span class="arrow-icon">→</span>
      </button>
    </div>

    <!-- Timestamp -->
    <span class="notification-time">
      {{ notification.created_at | date:'d MMM yyyy - HH:mm' }}
    </span>
  </div>

  <!-- Three-dot menu -->
  <div class="menu-container" *ngIf="!notification.read_at">
    <button class="menu-button" (click)="toggleMenu($event)" [class.active]="isMenuOpen">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.8333 10C15.8333 10.4603 15.4602 10.8334 15 10.8334C14.5397 10.8334 14.1666 10.4603 14.1666 10C14.1666 9.53977 14.5397 9.16668 15 9.16668C15.4602 9.16668 15.8333 9.53977 15.8333 10Z"
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M10.8333 10C10.8333 10.4603 10.4602 10.8334 10 10.8334C9.53977 10.8334 9.16668 10.4603 9.16668 10C9.16668 9.53977 9.53977 9.16668 10 9.16668C10.4602 9.16668 10.8333 9.53977 10.8333 10Z"
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M5.83332 10C5.83332 10.4603 5.46023 10.8334 5 10.8334C4.53976 10.8334 4.16666 10.4603 4.16666 10C4.16666 9.53977 4.53976 9.16668 5 9.16668C5.46023 9.16668 5.83332 9.53977 5.83332 10Z"
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>

    <!-- Dropdown menu -->
    <div class="menu-dropdown" *ngIf="isMenuOpen" (click)="$event.stopPropagation()">
      <button class="menu-item" (click)="markAsRead($event)" *ngIf="!notification.read_at">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.3334 4L6.00002 11.3333L2.66669 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        {{ 'notifications.mark_as_read' | translate }}
      </button>
      <div *ngIf="canBeSnooozed()">
        <button class="menu-item" (click)="snoozeNotification($event)">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.00002 4.66667V8.00001L10.6667 9.33334" stroke="currentColor" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M8.00002 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8.00001C14.6667 4.31811 11.6819 1.33334 8.00002 1.33334C4.31812 1.33334 1.33335 4.31811 1.33335 8.00001C1.33335 11.6819 4.31812 14.6667 8.00002 14.6667Z"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          {{ 'notifications.snooze' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>